import { OPEN_HREF_ATTRIBUTE } from '../../constants';
import { useOnHrefClick, useRevieveScript } from '../../hooks';
import { Loading } from '../Loading';
import { Restore } from '../Restore';
import { STATE_LOADING, STATE_RESTORED } from './constants';
import { useRevieve } from './hooks';
import type { RevieveProps } from './types';

export const Revieve = (props: RevieveProps) => {
  const { close, continueToPdp, initConfig, onInit, open, reset, state } = useRevieve(props);
  useRevieveScript({ initConfig, onInit });
  useOnHrefClick({ href: OPEN_HREF_ATTRIBUTE, onClick: open });

  return (
    <>
      <Loading show={state === STATE_LOADING} />
      <Restore
        show={state === STATE_RESTORED}
        onClose={close}
        onContinue={continueToPdp}
        onReset={reset}
      />
    </>
  );
};
